import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/pages/main/main.component';
import { KontaktComponent } from './components/pages/footer-pages/kontakt/kontakt.component'; 
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { GlobalConstantsRouting } from 'globales-projekt-angular';
import { FoerderungComponent } from './components/pages/navbar-pages/foerderung/foerderung.component';
import { AutorenZitierhinweiseComponent } from './components/pages/navbar-pages/autoren-zitierhinweise/autoren-zitierhinweise.component';
import { QuellenComponent } from './components/pages/navbar-pages/quellen/quellen.component';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { FaqComponent } from './components/pages/navbar-pages/faq/faq.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';

const routes: Routes = [
  { path: '', redirectTo: GlobalConstantsRouting.REDIRECT_TO, pathMatch: GlobalConstantsRouting.PATH_MATCH },
  { path: GlobalConstantsRouting.AUTOREN_ZITIERHINWEISE, component: AutorenZitierhinweiseComponent },
  { path: GlobalConstantsRouting.FOERDERUNG, component: FoerderungComponent },
  { path: GlobalConstantsRouting.MAIN, component: MainComponent },
  { path: GlobalConstantsRouting.ERGEBNISSE, component: ErgebnisseComponent },
  { path: GlobalConstantsRouting.QUELLEN, component: QuellenComponent },
  { path: GlobalConstantsRouting.HILFE, component: HilfeComponent },
  { path: GlobalConstantsRouting.FAQ, component: FaqComponent },
  { path: GlobalConstantsRouting.KONTAKT, component: KontaktComponent }, 
  { path: GlobalConstantsRouting.PAGE_NOT_FOUND, component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
